import { Toast,Dialog} from 'vant';
/**当前时间的年月日函数
 * type 返回的格式YYYY-MM-DD 默认
 * seperator:默认为"-" 连接符
 * timeStamp:需要转换的时间,默认为当前时间
 */
function getDate(type="YYYY-MM-DD",seperator="-",timeStamp) {
  let date = new Date()
  if (timeStamp) {
    date = new Date(timeStamp)
  }
  let year = date.getFullYear()
  let nowMonth = date.getMonth()+1
  let strDate = date.getDate()
  // 对月份进行处理，1-9月在前面添加一个“0”
  if (nowMonth >= 1 && nowMonth <= 9) {
    nowMonth = "0" + nowMonth;
  }
  // 对月份进行处理，1-9号在前面添加一个“0”
  if (strDate >= 0 && strDate <= 9) {
    strDate = "0" + strDate;
  }
  if (type=="YYYY-MM-DD") {
    return year + seperator + nowMonth + seperator + strDate;
  }
  if (type=="YYYY-MM") {
    return year + seperator + nowMonth;
  }
  if (type=="YYYY") {
    return year;
  }
}

// 节流函数
function throttle(func, delay) {
  let timeoutId;
  return function(...args) {
    if (!timeoutId) {
      timeoutId = setTimeout(() => {
        func.apply(this, args);
        timeoutId = null;
      }, delay);
    }
  };
}
// 防抖函数
function debounce(func, delay) {
  let timeoutId;
  return function(...args) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      func.apply(this, args);
    }, delay);
  };
}
// url参数获取
// 如str = '?params=%7B%22pn%22%3A%22managementIndex%22%2C%22data%22%3A%7B%22a%22%3A1%2C%22b%22%3A%22adsads%22%7D%7D'
function getUrlParam(str) {
  try {
    if(str){
      const arr = str.split('=')
      return JSON.parse(decodeURIComponent(arr[1]))
    }
  } catch(e) {
    console.log('传入的不是值',e)
  }

}

function isIos() {
  const uA = navigator.userAgent.toLowerCase();
  const iphone = uA.match(/iphone os/i) == "iphone os";
  if (iphone) {
    return true;
  } else {
    return false;
  }
}

function isAndroid() {
  const uA = navigator.userAgent.toLowerCase();
  const android = uA.match(/android/i) == "android";
  if (android) {
    return true;
  } else {
    return false;
  }
}

// 打电话
function callPhone(phoneNumber) {
  if (isAndroid()) {
    mobile.callPhone(phoneNumber + "");
  } else {
    location.href = 'tel:' + phoneNumber;
  }
}

    // 获取地址参数
 function getQueryString(str,name){
   var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
   var r = str.match(reg);
  if(r!=null)return unescape(r[2]); return null;
}
// 获取全局数据
function getGlobalData(str){
  try {
    if(str){
     let str1 = str.split('?')[1]
     let name = getQueryString(str1,'globalData')
     if (name) {
      let data =  JSON.parse(decodeURIComponent(name))
      window.globalData.apiPath = data.apiPath
      window.globalData.token = data.token
      window.globalData.openId = data.openId
      if (data.location) {
        window.globalData.location = JSON.parse(data.location)
      }
      if (data.sessionId) {
        window.globalData.sessionId = data.sessionId
      }
     }
     let name2 = getQueryString(str1,'typeParam')
     if (name2) {
      let data =  JSON.parse(decodeURIComponent(name2))
      window.globalData.typeParam = data
     }
     let name3 = getQueryString(str1,'systemInfo')
     if(name3){
      let data =  JSON.parse(decodeURIComponent(name3))
      window.globalData.systemInfo = data
     }
    }
  } catch(e) {
    console.log('传入的不是值',e)
  }
}
function setTimeoutFun (time, callBack) {    //延时器公共方法
  let tm = setTimeout(() => {
    clearTimeout(tm);
    callBack&&callBack();
  }, time)
}
// toast回调
function showToastBack(text, callBack,callbackTime=1500) {
  const timer1 = setTimeout(() => {
    Toast({
      message: text,
      className:'van-newToast'
    });
    clearTimeout(timer1)
    if (callBack) {
      const timer2 = setTimeout(() => {
        clearTimeout(timer2)
        callBack&&callBack()
      }, callbackTime)
    }
  }, 200)
}

      // 埋点公用方法
function buryingPoint(otherParam,callBack) {
  const systemInfo = window.globalData.systemInfo || {}
  const openId = window.globalData.openId || ''
  const param = {
    sessionId:window.globalData.sessionId,
    customerId: window.globalData.token,
    deviceBase: {
      "brand": systemInfo.brand || "",
      "city": "",
      "ip": "",
      "ipIsp": "",
      longitude:window.globalData.location.longitude||'',
      latitude:window.globalData.location.latitude||'',
      "manufacturer": systemInfo.brand,
      "mode": systemInfo.model,
      "networkType": "",
      "os": systemInfo.system,
      "osVersion": systemInfo.system,
      "platformType": systemInfo.platform,
      "screenHeight": systemInfo.screenHeight,
      "screenWidth": systemInfo.screenWidth,
      "version": systemInfo.version
    },
    enterpriseId: "",
    openId
  }
  const allParam = Object.assign(param,otherParam)
   callBack&&callBack(allParam)

  // return axios.$dataManager.adCollect(allParam).then((res) => {})
}
export default{
  getDate,
  getUrlParam,
  throttle,
  debounce,
  isIos,
  isAndroid,
  callPhone,
  getGlobalData,
  setTimeoutFun,
  showToastBack,
  buryingPoint
}



// WEBPACK FOOTER //
// ./src/common/utils.js